var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_circle_outline_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/content/remove_circle_outline_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.66797C5.40033 1.66797 1.66699 5.4013 1.66699 10.0013C1.66699 14.6013 5.40033 18.3346 10.0003 18.3346C14.6003 18.3346 18.3337 14.6013 18.3337 10.0013C18.3337 5.4013 14.6003 1.66797 10.0003 1.66797ZM3.33366 10.0013C3.33366 13.6763 6.32533 16.668 10.0003 16.668C13.6753 16.668 16.667 13.6763 16.667 10.0013C16.667 6.3263 13.6753 3.33464 10.0003 3.33464C6.32533 3.33464 3.33366 6.3263 3.33366 10.0013ZM5.83366 9.16797V10.8346H14.167V9.16797H5.83366Z",
    fill: "#8993A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleOutline);
export default __webpack_public_path__ + "static/media/remove_circle_outline.faa497245751e6cf62b72f57af03c346.svg";
export { ForwardRef as ReactComponent };